import { SystemExportRow } from 'components/tables/data/system-export/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the system export id.
 */
export default function SystemExportIdColumn({ data: { systemExportId } }: { data: SystemExportRow }) {
  return <P3Regular color="gray.8">{systemExportId}</P3Regular>;
}
